import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
// import { ImportOrderComponent } from './orders/container/import-order/import-order.component';
import { auth2Guard } from './_guard/auth2.guard';
import { authGuard } from './_guard/auth.guard';
import { PagenotfoundComponent } from './shared/component/pagenotfound/pagenotfound.component';

const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: '',
    // canLoad: [auth2Guard],
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    component: HomeLayoutComponent,
    canActivate: [authGuard],
    children: [
      // {
      //   path: 'import-order',
      //   component: ImportOrderComponent,
      //   // canActivate: [AuthGuard],
      //   data: { title: 'Opollo WMS' }
      // },
      
      {
        path: 'access-management-services',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/access-management/access-management.module').then(m => m.AccessManagementModule)
      },
      
      {
        path: 'dashboardnm',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'setting',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./setting/setting.module').then(m => m.SettingModule)
      },
      {
        path: 'utility',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/utility/utility.module').then(m => m.UtilityModule)
      },
      {
        path: 'account-configuration',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/account-configuration/account-configuration.module').then(m => m.AccountConfigurationModule)
      },
      {
        path: 'orders',
        loadChildren: () => import('./module/orders/orders/orders-routing.module').then(m => m.ordersRoutingModule)
      },
      {
        path: 'master',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/ptl-master/ptl-master/ptl-master.module').then(m => m.PtlMasterModule)
      },
      {
        path: 'dashboard',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/analytics/analytics.module').then(m => m.AnalyticsModule)
      },
      {
        path: 'vendors',
        loadChildren: () => import('./module/vendors/vendors.module').then(m => m.VendorsModule)
      },
      {
        path: 'trip',
        loadChildren: () => import('./module/trip/trip.module').then(m => m.TripModule)
      },
      {
        path: 'configuration',
        loadChildren: () => import('./module/tms-configuration/tms-configuration.module').then(m => m.TmsConfigurationModule)
      },
      {
        path: 'claim',
        loadChildren: () => import('./module/claim/claim.module').then(m => m.ClaimModule)
      },
      {
        path: 'e-waybill',
        loadChildren: () => import('./module/e-waybill/e-waybill.module').then(m => m.EWaybillModule)
      },
      {
        path: 'payments',
        loadChildren: () => import('./module/payments/payments.module').then(m => m.PaymentsModule)
      },
      {
        path: 'vendor-billing',
        loadChildren: () => import('./module/vendor-billing/vendor-billing.module').then(m => m.VendorBillingModule)
      },
      {
        path: 'customer-billing',
        loadChildren: () => import('./module/customer-billing/customer-billing.module').then(m => m.CustomerBillingModule)
      },
      {
        path: 'customers',
        loadChildren: () => import('./module/customers/customers.module').then(m => m.customersModule)
      },
      {
        path: 'tracking',
        loadChildren: () => import('./module/tracking/tracking.module').then(m => m.TrackingModule)
      },
      {
        path: 'mis-mapping',
        loadChildren: () => import('./module/mis-mapping/mis-mapping.module').then(m => m.MISMappingModule)
      },
      {
        path: 'quality',
        loadChildren: () => import('./module/quality/quality.module').then(m => m.QualityModule)
      },
      {
        path: 'finance',
        loadChildren: () => import('./module/finance/finance.module').then(m => m.FinanceModule)
      },
    ]
  },
  { path: 'pageNotFound', component: PagenotfoundComponent},
  

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
